// extracted by mini-css-extract-plugin
module.exports = {"block":"_9801","title":"_13113","list":"_2969","item":"_4142","cover":"_6890","name":"_18392","price":"_15699","current":"_1904","cost":"_126"};